<h5 mat-dialog-title i18n>Job Cost Report</h5>
<div mat-dialog-content>
  <p i18n>Please define the filters below</p>
  <form #parameterForm="ngForm" (ngSubmit)="runReport(parameterForm)">
    <div class="form-group row">
      <div class="col-sm-6">
        <div class="control-wrapper">
          <label for="customerId" class="col-sm-3 col-form-label" i18n>Customer</label>

          <input type="text" name="customer_BusinessName" id="customer_BusinessName"
                 class="form-control"
                 autocomplete="off"
                 matInput
                 [formControl]="customerControl"
                 [matAutocomplete]="customerAuto" />
          <mat-autocomplete autoActiveFirstOption #customerAuto="matAutocomplete">
            <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer.customer_BusinessName">{{customer.customer_BusinessName}}</mat-option>
          </mat-autocomplete>
        </div>
        <div class="control-wrapper">
          <label for="quoteId" class="col-sm-3 col-form-label" i18n>Job</label>

          <input type="text" name="quote_Name" id="quote_Name"
                 class="form-control"
                 autocomplete="off"
                 matInput
                 [formControl]="jobControl"
                 [matAutocomplete]="jobAuto" />
          <mat-autocomplete autoActiveFirstOption #jobAuto="matAutocomplete">
            <mat-option *ngFor="let job of filteredJobs | async" [value]="job.quote_Name">{{job.quote_Name}}</mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <div class="col-sm-6">
        <p i18n>Define Time Frame</p>
        <div class="control-wrapper">
          <label for="startDate" class="col-sm-3 col-form-label" i18n>Start Date</label>
          <div class="form-inline">
            <input name="startDate" id="startDate" class="form-control narrow-input" matInput
                   placeholder="mm/dd/yyyy"
                   [matDatepicker]="startPicker"
                   [(ngModel)]="data.startDate" #startDate="ngModel" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </div>
        </div>
        <div class="control-wrapper">
          <label for="endDate" class="col-sm-3 col-form-label" i18n>End Date</label>
          <div class="form-inline">
            <input name="endDate" id="endDate" class="form-control narrow-input" matInput
                   placeholder="mm/dd/yyyy"
                   [matDatepicker]="endPicker"
                   [(ngModel)]="data.endDate" #endDate="ngModel" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </div>
        </div>
      </div>

    </div>
    <div *ngIf="errors" class="alert alert-danger">
      {{errors}}
    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
      <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
  </form>
</div>

